<style>
.page-item{
        cursor:pointer;
}
.skeleton-line {
  height: 14px;
  width: 100%;
  background: linear-gradient(
    90deg,
    #eeeeee 25%,
    #dddddd 37%,
    #eeeeee 63%
  );
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: 4px;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.text-muted i {
  color: #999;
}

</style>

<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3 class="card-title">Daftar Barang Masuk</h3>
            </div>  
        </div>
        		
		<!--
		<div v-if="unitkerjas.length && unitkerjas[0].tingkat == '2'" class="row">
            <div class="col-12" style="padding-bottom:10px;">
                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                    <i class="fa fa-plus-square"></i>
                    Entry Saldo Awal +
                </button>
            </div>
        </div>-->
		
		<!-- TOOLBAR FILTER TAHUN (DI ATAS CARD) -->
		<div class="d-flex justify-content-between align-items-center mb-2">

		  <!-- KIRI (opsional, biar sejajar tombol saldo awal) -->
		  <div>
			  <div
				v-if="unitkerjas.length && unitkerjas[0].tingkat != '2'"
				class="mb-2"
			  >
				<button class="btn btn-sm btn-primary" @click="newModal">
				  <i class="fa fa-plus-square"></i> Tambah Barang Masuk
				</button>
			  </div>

			  <div
				v-if="unitkerjas.length && bolehSaldoAwal && unitkerjas[0].tingkat == '2' && !saldoAwalSudahAda"
				class="mb-2"
			  >
				<button class="btn btn-sm btn-primary" @click="openSaldoAwalPreview">
				  <i class="fa fa-plus-square"></i> Entry Saldo Awal +
				</button>
			  </div>
			</div>

		  <!-- KANAN (ABSOLUTE) -->
		  <div class="d-flex align-items-center">
			<!-- SUMBER DANA -->
			  <label class="mr-2 font-weight-bold mb-0">Sumber Dana</label>
			  <select
				v-model="filterSumberDana"
				class="form-control form-control-sm mr-3"
				style="width:130px"
				@change="getResults(1)"
			  >
				<option value="">Semua</option>
				<option v-for="sd in sumberdanas" :key="sd.id" :value="sd.id">
				  {{ sd.nama }}
				</option>
			  </select>
			  
			<template v-if="unitkerjas.length && unitkerjas[0].tingkat == '2'">
				<label class="mr-2 font-weight-bold mb-0">Verifikasi</label>
			  <select
				v-model="statusVerifikasi"
				class="form-control form-control-sm"
				style="width:130px"
				@change="getResults(1)"
			  >
				<option value="">Semua</option>
				<option value="2">Diterima</option>
				<option value="1">Ditolak</option>
				<option value="0">Menunggu</option>
			  </select>
			</template>
			
			&nbsp;
			
			  <label class="mr-2 font-weight-bold mb-0">Tahun</label>
			  <select
				v-model="tahunBarangMasuk"
				class="form-control form-control-sm"
				style="width:130px"
				@change="getResults(1)"
			  >
				<option value="">Pilih</option>
				<option v-for="t in listTahunBarangMasuk" :key="t" :value="t">
				  {{ t }}
				</option>
			  </select>
			</div>


		</div>

        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Data
                <div class="card-tools">
                    <input type="text" v-model="searchTerm"  placeholder="Cari" :disabled="!tahunBarangMasuk">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th role='button' v-on:click="sortRecords('id', 'barang_masuk')">ID</th>
                      <th role='button' v-on:click="sortRecords('tanggal_masuk', 'barang_masuk')">Tanggal Pencairan</th>
                      <th role='button' v-on:click="sortRecords('nama', 'sumber_dana')">Sumber Dana</th>
                      <th role='button' v-on:click="sortRecords('nama', 'unit_kerja')">Unit Kerja</th>
                      <th role='button' v-on:click="sortRecords('nama', 'penyedia')">Penyedia</th>
                      <th role='button' v-on:click="sortRecords('no_nota', 'barang_masuk')">No Nota</th>
                      <th role='button' v-on:click="sortRecords('total', 'total')">Total (Rp)</th>
                      <th v-if="unitkerjas.length && unitkerjas[0].tingkat == '2'" role='button'>Verifikasi</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
					<!-- SKELETON -->
					<template v-if="isLoadingTable">
						<tr v-for="n in 5" :key="'sk-'+n">
						  <td colspan="10">
							<div class="skeleton-line"></div>
						  </td>
						</tr>
					</template>

					<!-- BELUM PILIH TAHUN -->
					<tr v-else-if="!tahunBarangMasuk">
						<td colspan="10" class="text-center text-muted py-4">
						  Silakan pilih tahun untuk menampilkan data
						</td>
					</tr>

					<!-- DATA KOSONG -->
					<tr v-else-if="isDataKosong">
						<td colspan="10" class="text-center text-muted py-4">
						  <i class="fa fa-info-circle mr-1"></i>
						  Belum ada transaksi barang masuk pada tahun
						  <strong>{{ tahunBarangMasuk }}</strong>
						</td>
					</tr>

					<!-- DATA ADA -->
					<template v-else>
						 <tr v-for="barangmasuk in barangmasuks.data" :key="barangmasuk.id" @click="previewBarangMasuk(barangmasuk)">

						  <td>{{barangmasuk.id}}</td>
						  <td class="text-capitalize">{{barangmasuk.tanggal_masuk}}</td>
						  <td>{{barangmasuk.nama_sumber_dana}}</td>
						  <td>{{barangmasuk.nama_unit_kerja}}</td>
						  <td>{{barangmasuk.nama_penyedia}}</td>
						   <td>{{barangmasuk.no_nota}}</td>
						   <td style="text-align:right">{{returnRupiahBulat(barangmasuk.total)}}</td>
						   <td style="text-align:center" v-if="unitkerjas.length && unitkerjas[0].tingkat == '2'">
						   
						   <!-- Jika Saldo Awal (penyedia_id == 1400) -->
							<span v-if="barangmasuk.penyedia_id == 1400">
								<span class="button btn-success" style="padding:0.2rem 0.375rem !important; border-radius:5px; text-decoration:none; cursor:default;">
									Diterima
								</span>
							</span>
							
							<!-- Jika Bukan Saldo Awal -->
							<template v-else>
							
								<span v-if="barangmasuk.status_terima == '1'">
									<a class="button btn-danger" style="padding:0.2rem 0.375rem !important; border-radius:5px; text-decoration:none;" href="#" @click.stop="loadAccModal(barangmasuk)">Ditolak</a>
								</span>
								<span v-else-if="barangmasuk.status_terima == '2'">
									<a class="button btn-success" style="padding:0.2rem 0.375rem !important; border-radius:5px; text-decoration:none;" href="#" @click.stop="loadAccModal(barangmasuk)">Diterima</a>
								</span>
								<span v-else-if="barangmasuk.status_terima == '0'">
								<a class="button btn-primary" style="padding:0.2rem 0.375rem !important; border-radius:5px; text-decoration:none;" href="#" @click.stop="loadAccModal(barangmasuk)">Verifikasi</a></span>
							</template>	
							</td>
						  <td style="text-align:center">
							
							<!--<router-link :to='"/detail_barang_masuk?barang_masuk_id=" + barangmasuk.id + "&status_kunci=" + barangmasuk.selisih + "&tingkat=" + barangmasuk.tingkat'' >-->
							<router-link @click.stop :to="{path: '/detail_barang_masuk', query: {barang_masuk_id: barangmasuk.id, tahun: tahunBarangMasuk}}">
									<i class="nav-icon fas fa-list-ul red"></i>
								</router-link>

							 &nbsp;
							 <a v-if="barangmasuk.selisih >= '0' && barangmasuk.tingkat != '2'" href="#" @click.stop="editModal(barangmasuk, barangmasuk.selisih)">
								<i class="fa fa-edit blue"></i>
							</a>

							<!--
							<a href="#" @click="editModal(barangmasuk, barangmasuk.selisih)">
								<i class="fa fa-edit blue"></i>
							</a>-->
							
							&nbsp;
							<a v-if="barangmasuk.selisih >= '0' && barangmasuk.tingkat != '2'" href="#" @click.stop="deleteData(barangmasuk.id)">
								<i class="fa fa-trash red"></i>
							</a>
							
							<!--
							<a href="#" @click="deleteData(barangmasuk.id)">
								<i class="fa fa-trash red"></i>
							</a>-->
						  </td>
						</tr>

						 <tr>
							<td colspan="6" style="font-weight:bold; text-align:center;">Grand Total</td>
							<td style="font-weight:bold; text-align:right;">{{returnRupiahBulat(grandtotal)}}</td>
							<td v-if="unitkerjas.length && unitkerjas[0].tingkat == '2'"></td>
							<td></td>
						</tr>
					</template>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                    <div class="row">                  
                        <div class="col-12">
                            <pagination :records="parseInt(barangmasuks.total)" v-model="page" :per-page="perPage" :options="{texts: { count: 'Menampilkan data ke {from} sampai {to} dari total {count} data|{count} records|One record' }}" @paginate="getResults"></pagination>
                        </div>
                  </div>
                  <div class="row">
                        <div class="col-12">
                                Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Data
                        </div>
                    </div>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>
		
        <!-- Modal ACC -->
         <!-- Modal -->
        <div class="modal fade" id="modalACC" tabindex="-1" role="dialog" aria-labelledby="modalACC" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" v-show="!editmode">Verifikasi Barang Masuk</h5>
                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <form @submit.prevent="kirimStatus()">
                        <div class="modal-body">
                            <!--<div v-if="statusTerima == false" class="form-group">-->
			    <div class="form-group">

                                <label style="display:block;">Status</label>
                                
                                <input v-model="form.status_terima" type="radio" id="status_terima" name="status_terima"
                                value="2" :class="{ 'is-invalid': form.errors.has('Status') }"><label for="2"> Terima</label>
                                &nbsp;
                                <input v-model="form.status_terima" type="radio" id="status_terima" name="status_terima"
                                value="1" :class="{ 'is-invalid': form.errors.has('Status') }"><label for="1"> Kembalikan</label>
                                <has-error :form="form" field="status_terima"></has-error>
                            </div>

                            <!--<div v-else class="form-group">
                                <label style="display:block;">Status : {{statusTerimaStr}}</label>
                            </div>-->

                            <!--<div v-if="statusTerima == false" class="form-group">-->
			    <div class="form-group">
                                <label>Keterangan</label>
                                <input v-model="form.keterangan" type="text" id="keterangan" name="keterangan"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Keterangan') }">
                                <has-error :form="form" field="keterangan"></has-error>
                            </div>

                            <!--<div v-else class="form-group">
                                <label style="display:block;">Keterangan : {{form.keterangan}}</label>
                            </div>-->

			    <label style="display:block;">Tanggal Verifkasi : {{form.tgl_verif}}</label>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                
                                <!--<button v-if="statusTerima == false" type="submit" class="btn btn-primary">Simpan</button>-->
				<button type="submit" class="btn btn-primary">Simpan</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>        
        <!---->

        <!-- Modal add/ edit-->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" v-show="!editmode">Tambah Barang Masuk</h5>
						<h5 class="modal-title" v-show="editmode">Ubah Barang Masuk</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<!-- <form @submit.prevent="createUser"> -->

					<form @submit.prevent="editmode ? updateBarangMasuk() : createBarangMasuk()">
						<div class="modal-body">
							<div class="form-group">
								<label>Tanggal Masuk</label>
								<datepicker v-model="form.tanggal_masuk" :disabledDates="disabledAkhir" :format="format" name="tanggal_masuk" class="form-controlx" :class="{ 'is-invalid': form.errors.has('tanggal_masuk') }"></datepicker>
								<has-error :form="form" field="tanggal_masuk"></has-error>
							</div>
							<div class="form-group">
								<label>Sumber Dana</label>
								<select v-model="form.sumber_dana_id" name="sumber_dana_id" class="form-control" :class="{ 'is-invalid': form.errors.has('Sumber Dana') }">
								 <option selected value="">Pilih salah satu</option>

								<option v-for="sumberdana in sumberdanas" :value="sumberdana.id">
									{{ sumberdana.nama }}
								</option>

								</select>
								<has-error :form="form" field="sumber_dana_id"></has-error>
							</div>
							<div class="form-group">
								<label>Unit Kerja</label>
								<select v-model="form.unit_kerja_id" name="unit_kerja_id" class="form-control" :class="{ 'is-invalid': form.errors.has('Unit Kerja') }">
								 <option selected value="">Pilih salah satu</option>

								<option v-for="unitkerja in unitkerjas" :value="unitkerja.id">
									{{ unitkerja.nama }}
								</option>

								</select>
								<has-error :form="form" field="unit_kerja_id"></has-error>
							</div>
							<div class="form-group">
								<label>Penyedia</label>
								<select v-model="form.penyedia_id" name="penyedia_id" class="form-control" :class="{ 'is-invalid': form.errors.has('Unit Kerja') }">
								 <option selected value="">Pilih salah satu</option>

								<option v-for="penyedia in penyedias" :value="penyedia.id">
									{{ penyedia.nama }}
								</option>

								</select>
								<has-error :form="form" field="penyedia_id"></has-error>
							</div>
							<div class="form-group">
								<label>No Nota</label>
								<input v-model="form.no_nota" type="text" name="no_nota"
									class="form-control" :class="{ 'is-invalid': form.errors.has('No Nota') }">
								<has-error :form="form" field="no_nota"></has-error>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
							<button v-show="editmode" v-if="statusKunci == false" type="submit" class="btn btn-success">Simpan</button>
							<button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
						</div>
					</form>
                </div>
            </div>
        </div>
		<!------ -->
		
		<!-- modal saldo awal -->
		<div class="modal fade" id="modalSaldoAwal" tabindex="-1" role="dialog" aria-labelledby="modalSaldoAwal" aria-hidden="true">

		  <div class="modal-dialog modal-xl" role="document">
			<div class="modal-content">
			  <div class="modal-header">
				<h5 class="modal-title">Preview Saldo Awal</h5>
				<button type="button" class="close" @click="tutupModalSaldoAwal">
				  <span>&times;</span>
				</button>
			  </div>

			 <div class="modal-body">
				<div v-if="loadingSaldoAwal" class="text-center">
				  <i class="fa fa-spinner fa-spin"></i> Menghitung saldo awal...
				</div>

				<table
				  v-else
				  class="table table-bordered table-sm"
				>
				  <thead>
					<tr>
					<th>No</th>
					  <!--th>Kode Rekening</th>
					  <th>Rekening</th>-->
					  <th>Sumber Dana</th>
					  <th>Nama Barang</th>
					  <th>Keterangan</th>
					  <th>Satuan</th>
					  <th>Stok</th>
					  <th>Harga</th>
					  <th>Total</th>
					</tr>
				  </thead>

				  <tbody>
					<template v-for="(group, gIndex) in groupedSaldoAwal" :key="gIndex">

					<!-- HEADER REKENING -->
					<tr class="bg-light font-weight-bold">
					  <td colspan="9">
						{{ group.kode_rekening }} - {{ group.nama_rekening }}
					  </td>
					</tr>

					<!-- DETAIL BARANG -->
					<tr v-for="(item, i) in group.items" :key="i">
					  <td>{{ i + 1 }}</td>
					  <!--<td>{{ item.kode_rekening }}</td>
					  <td>{{ item.nama_rekening }}</td>-->
					  <td>{{ item.nama_sumber_dana }}</td>
					  <td>{{ item.nama_barang }}</td>
					  <td>{{ item.keterangan }}</td>
					  <td>{{ item.nama_satuan }}</td>
					  <td class="text-right">{{ item.qty }}</td>
					  <td class="text-right">{{ returnRupiah(item.harga) }}</td>
					  <td class="text-right">{{ returnRupiah(item.subtotal) }}</td>
					</tr>

					<!-- SUBTOTAL PER REKENING -->
					<tr class="font-weight-bold bg-light">
					  <td colspan="7" class="text-right">
						Subtotal Rekening
					  </td>
					  <td class="text-right">
						{{ returnRupiah(group.subtotal) }}
					  </td>
					</tr>

				  </template>
				  </tbody>
				  
				  <tfoot>
					<tr>
					  <th colspan="7" class="text-right">GRAND TOTAL</th>
					  <th class="text-right">
						{{ returnRupiah(grandTotalSalwal) }}
					  </th>
					</tr>
				  </tfoot>
  
				</table>
			  </div>

			  <div class="modal-footer">
				<button class="btn btn-secondary" @click="tutupModalSaldoAwal">
				  Batal
				</button>
				
				<button
				  class="btn btn-primary"
				  :loading="loading"
				  @click="simpanSaldoAwal"
				>
				  Simpan Saldo Awal
				</button>
				
			  </div>
			</div>
		  </div>
		</div>

		<!---------- -->
		
		<!-- MODAL PREVIEW BARANG MASUK -->
		<div class="modal fade" id="modalPreviewBarangMasuk" tabindex="-1">
		  <div class="modal-dialog modal-xl">
			<div class="modal-content">

			  <div class="modal-header">
				<h5 class="modal-title">Preview Detail Barang Masuk</h5>
				<button type="button" class="close" @click="tutupModalPreview">
				  <span>&times;</span>
				</button>
			  </div>

			  <div class="modal-body">

<!--			  <div class="col-md-4"><b>No Nota:</b> {{ previewHeader.no_nota }}</div>
				  <div class="col-md-4"><b>Tanggal:</b> {{ previewHeader.tanggal_masuk }}</div>
				  <div class="col-md-4"><b>Unit:</b> {{ previewHeader.nama_unit_kerja }}</div>
				</div>
*-->
				<table class="table table-sm table-bordered">
				  <thead>
					<tr>
					  <th>Barang</th>
					  <th>Satuan</th>
					  <th>Qty</th>
					  <th>Harga</th>
					  <th>Total</th>
					</tr>
				  </thead>
				  <tbody>
					<tr v-if="loadingPreview">
					  <td colspan="5" class="text-center">
						<i class="fa fa-spinner fa-spin"></i> Loading...
					  </td>
					</tr>

					<tr v-for="d in previewDetails" :key="d.id">
					  <td>{{ d.nama_barang }}</td>
					  <td>{{ d.nama_satuan }}</td>
					  <td class="text-right">{{ d.qty }}</td>
					  <td class="text-right">{{ returnRupiah(d.harga) }}</td>
					  <td class="text-right">{{ returnRupiah(d.qty * d.harga) }}</td>
					</tr>
				  </tbody>
				</table>

			  </div>

			  <div class="modal-footer">
				<button class="btn btn-secondary" @click="tutupModalPreview">
				  Tutup
				</button>
				<button class="btn btn-primary" @click="goToDetailBarangMasuk(previewHeader.id)">
				  Lihat Detail / Edit
				</button>
			  </div>

			</div>
		  </div>
		</div>

		<!---------- -->
		
    </div>
  </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Pagination from 'vue-pagination-2';

    export default {
        components: {
            Pagination,
            Datepicker
        },
        data () {
            return {
                editmode: false,
                statusTerima:false,
                statusTerimaStr:'',
                searchTerm:'',
                statusKunci: false,
                barangmasuks : {},
                unitkerjas : {},
                sumberdanas : {},
                penyedias : {},
                grandtotal :0,
                format: 'yyyy-MM-dd',
                akhir:'',
                tanggalKunci:'',
                disabledAkhir: {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(),
                        to: new Date(2100, 11, 31)
                    }]
                },
                form: new Form({
                    id : '',      
                    tanggal_masuk: '',
                    sumber_dana_id: '',
                    unit_kerja_id: '',
                    penyedia_id:'',
                    no_nota:'',
                    total:'',
                    status_terima:'',
                    keterangan:'',
					tgl_verif:'',
                }),
                sortIndex: 'tanggal_masuk',
                sortDirection: 'desc',
                perPage:10,
                showTable:'barang_masuk',
                page: 1,
				//saldo awal
				loadingSaldoAwal: false,
				previewSaldoAwal: [], // hasil hitung stok
				grandTotalSalwal: 0,
				
				//tahun load
				//tahunBarangMasuk: new Date().getFullYear(), // ⬅️ default tahun berjalan,
				tahunBarangMasuk: this.$route.query.tahun ? parseInt(this.$route.query.tahun) : new Date().getFullYear(),
				listTahunBarangMasuk: [],
				isLoadingTable: false, // ⬅️ untuk skeleton
				statusVerifikasi: '', // '' = semua
				saldoAwalSudahAda: false,
				filterSumberDana: '',
				showPreviewModal: false,
				loadingPreview: false,
				previewHeader: {},
				previewDetails: [],
            }
        },
		
		computed: {
			bolehSaldoAwal() {
				return this.unitkerjas?.[0]?.status_saldo_awal === 'Y'
			},
			
			groupedSaldoAwal() {
				const groups = {}

				this.previewSaldoAwal.forEach(item => {
				  const key = item.kode_rekening || 'TANPA_REKENING'

				  if (!groups[key]) {
					groups[key] = {
					  kode_rekening: item.kode_rekening,
					  nama_rekening: item.nama_rekening,
					  items: [],
					  subtotal: 0
					}
				  }

				  const subtotal = item.qty * item.harga
				  groups[key].items.push({
					...item,
					subtotal
				  })
				  groups[key].subtotal += subtotal
				})

				return Object.values(groups)
			},
			
			isDataKosong() {
				return (
				  !this.isLoadingTable &&
				  this.tahunBarangMasuk &&
				  this.barangmasuks?.data &&
				  this.barangmasuks.data.length === 0
				)
			  }
		},
	
        methods: {
			//saldo awal
			openSaldoAwalPreview () {
			  this.loadPreviewSaldoAwal();
			},

			async loadPreviewSaldoAwal() {
				$('#modalSaldoAwal').modal('show');
				this.loadingSaldoAwal = true;
				
				try {
					const res = await axios.get('/api/saldo-awal/preview', {
					  params: { tahun: 2025 }
					})
					
					console.log('RES DATA:', res.data)
					console.log('RES DATA.DATA:', res.data.data)
					this.previewSaldoAwal = res.data.data;
					this.grandTotalSalwal = res.data.grandTotalSalwal
				  } catch (e) {
					Toast.fire({
					  icon: 'error',
					  title: 'Gagal mengambil preview saldo awal'
					})
				  } finally {
					this.loadingSaldoAwal = false;
				  }
			},
			tutupModalSaldoAwal() {
				$('#modalSaldoAwal').modal('hide');
			},			
			
			async simpanSaldoAwal() {
			  if (!this.previewSaldoAwal.length) {
				Toast.fire({
				  icon: 'warning',
				  title: 'Data saldo awal kosong'
				})
				return
			  }

			  const confirm = await Swal.fire({
				title: 'Simpan Saldo Awal?',
				text: 'Saldo awal hanya boleh disimpan satu kali per tahun',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Ya, Simpan',
				cancelButtonText: 'Batal'
			  })

			  if (!confirm.isConfirmed) return

			  this.loading = true

			  try {
				const payload = {
				  tahun: this.tahunBarangMasuk,
				  items: this.previewSaldoAwal.map(item => ({
					barang_id: item.barang_id,
					qty: item.qty,
					harga: item.harga,
					sumber_dana_id: item.sumber_dana_id,
					unit_kerja_id: item.unit_kerja_id
				  }))
				}

				const res = await axios.post('/api/saldo-awal/store', payload)

				Toast.fire({
				  icon: 'success',
				  title: res.data.message || 'Saldo awal berhasil disimpan'
				})

				this.tutupModalSaldoAwal()

				// refresh tabel barang masuk
				this.getResults(1)

			  } catch (e) {
				Toast.fire({
				  icon: 'error',
				  title: e.response?.data?.message || 'Gagal menyimpan saldo awal'
				})
			  } finally {
				this.loading = false
			  }
			},
			
			///////
			 
            sortRecords (index, tableName) {
               
                /*this.sortIndex = index;
                this.showTable = tableName;
                if(this.sortDirection == 'asc'){
                   this.sortDirection = 'desc';
                }else if(this.sortDirection == 'desc'){
                   this.sortDirection = 'asc';
                }else{
                   this.sortDirection = 'asc';
                }
                
                this.$Progress.start();
                
                this.page = 1;
                axios.get('/api/barang_masuk?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.barangmasuks = data.data.barang_masuk, this.sumberdanas = data.data.sumber_dana, this.unitkerjas = data.data.unit_kerja, this.penyedias = data.data.penyedia, this.grandtotal = data.data.grand_total));


                this.$Progress.finish();*/
				
				this.sortIndex = index
				  this.showTable = tableName

				  this.sortDirection =
					this.sortDirection === 'asc' ? 'desc' : 'asc'

				  this.page = 1
				  this.getResults(1)
            },    
            changePageRange(){
                /*this.$Progress.start();
                  this.page = 1;

                    axios.get('/api/barang_masuk?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.barangmasuks = data.data.barang_masuk, this.sumberdanas = data.data.sumber_dana, this.unitkerjas = data.data.unit_kerja, this.penyedias = data.data.penyedia, this.grandtotal = data.data.grand_total));

                  this.$Progress.finish();*/
				
				this.page = 1
				this.getResults(1)  
            },
            /*returnRupiah(val){
                if (val === null || val === undefined || val === '') return 0;

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2, // tetap tampil .5 / .50
				}).format(val);
            },*/
			
			/*
			returnRupiahBulat(val){
				if (val === null || val === undefined || val === '') return '0,00';

				let angka = parseFloat(val);
				let decimal = angka - Math.floor(angka);

				if (decimal >= 0.5) {
					angka = Math.ceil(angka);
				} else {
					angka = Math.floor(angka);
				}

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(angka);
			},*/
			
			returnRupiahBulat(val){
				return Number(val).toLocaleString('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			},
			
			returnRupiah(val){
                if (val === null || val === undefined || val === '') return '0,00';

				let angka = parseFloat(val);

				let decimal = angka - Math.floor(angka);

				if (decimal >= 0.5) {
					angka = Math.ceil(angka); // bulatkan ke atas
				}

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(angka);
            },

			previewBarangMasuk(item) {
			  this.loadingPreview = true
			  this.previewHeader = item
			  this.previewDetails = []
				
				$('#modalPreviewBarangMasuk').modal('show')
				
			  axios.get('/api/barang_masuk/' + item.id + '/preview')
				.then(res => {
				  this.previewDetails = res.data.data.details
				})
				.finally(() => {
				  this.loadingPreview = false
				})
			},
			//path: '/detail_barang_masuk', query: {barang_masuk_id: barangmasuk.id, tahun: tahunBarangMasuk}
			
			goToDetailBarangMasuk(id) {
			  this.$router.push({
				path: '/detail_barang_masuk',
				query: {
				  barang_masuk_id: id,
				  tahun: this.tahunBarangMasuk
				}
			  })
			  $('#modalPreviewBarangMasuk').modal('hide');
			},
			
			tutupModalPreview() {
				$('#modalPreviewBarangMasuk').modal('hide');
			},
			
            getResults(page = 1) {

                  /*this.$Progress.start();
                  
                  axios.get('/api/barang_masuk?page=' + page + '&tahun=' + this.tahunBarangMasuk + '&status_verifikasi=' + this.statusVerifikasi + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.barangmasuks = data.data.barang_masuk, this.sumberdanas = data.data.sumber_dana, this.unitkerjas = data.data.unit_kerja, this.penyedias = data.data.penyedia, this.grandtotal = data.data.grand_total));

                  this.$Progress.finish();*/
				  
				  // ⛔ jangan load data kalau tahun belum dipilih
				  if (!this.tahunBarangMasuk) {
					this.barangmasuks = { data: [], total: 0 }
					this.grandtotal = 0
					return
				  }

					this.isLoadingTable = true
				  this.$Progress.start()

				  axios.get('/api/barang_masuk', {
					params: {
					  page: page,
					  tahun: this.tahunBarangMasuk,
					  status_verifikasi: this.statusVerifikasi,
					  sumber_dana_id: this.filterSumberDana,
					  sortIndex: this.sortIndex,
					  sortDirection: this.sortDirection,
					  showPage: this.perPage,
					  showTable: this.showTable
					}
				  }).then(({ data }) => {
					this.barangmasuks = data.data.barang_masuk
					this.sumberdanas  = data.data.sumber_dana
					this.unitkerjas   = data.data.unit_kerja
					this.penyedias    = data.data.penyedia
					this.grandtotal  = data.data.grand_total
					this.saldoAwalSudahAda = data.data.saldo_awal_sudah_ada
				  }).finally(() => {
					this.isLoadingTable = false
					this.$Progress.finish()
				  })
            },
            updateBarangMasuk(){
                this.$Progress.start();
                this.form.put('/api/barang_masuk/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadBarangMasuks();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },

            kirimStatus(){
                
                this.$Progress.start();

                this.form.put('/api/barang_masuk/'+this.form.id)
                .then((response) => {
                    // success
                    $('#modalACC').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });

					var statusTerimaKirim = '0';
                    if(this.form.status_terima == '2'){
                        statusTerimaKirim = '1';
                    }else{
                        statusTerimaKirim = '0';
                    }
                        //alert(statusTerimaKirim);
                    $.ajax({
                        'async': false,
                        'type': 'POST',
                        'global': false,
                        'dataType': 'json',
                        'url': 'https://siblud.sidoarjokab.go.id/api/update_status_blud_silo',
                        'data':{"id":this.form.id, "status":statusTerimaKirim, "ket":this.form.keterangan, "tgl_verif":this.form.tgl_verif, "pin":"lalawidi", "sumber_dana":this.form.sumber_dana_id},
                    }).done(function(response){
                        //alert(response);
                    });


                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadBarangMasuks();
                })
                .catch(() => {
                    this.$Progress.fail();
                });
            },

            deleteData(id){
              Swal.fire({
                  title: 'Apa anda yakin?',
                  text: "Setelah terhapus data tidak bisa dikembalikan!",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Ya'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                            this.form.delete('/api/barang_masuk/'+id)
                            .then((response)=>{
                                
                                Toast.fire({
                                        icon: 'success',
                                        title: response.data.message
                                });

                                this.$Progress.finish();

                            })
                            .catch(()=>{
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Some error occured! Please try again'
                                });
                            })

                            window.location.reload();
                        }
                  })
             },
            editModal(barang_masuk, selisih){
                 this.tanggalKunci = new Date(this.unitkerjas[0].tanggal_kunci);
                this.disabledAkhir = {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(1900, 1, 31),
                        to: new Date(this.tanggalKunci.getFullYear(), this.tanggalKunci.getMonth(), this.tanggalKunci.getDate())
                    }]
                };

                if(parseFloat(selisih) >= 0){
                    this.statusKunci = false;
                }else{
                     this.statusKunci = true;
                }

                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(barang_masuk);
            },
            newModal(){
                this.tanggalKunci = new Date(this.unitkerjas[0].tanggal_kunci);

                this.disabledAkhir = {
                    dates:[
                        //new Date(2025, 0, 1) /*saldo awal*/
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(1900, 1, 31),
                        to: new Date(this.tanggalKunci.getFullYear(), this.tanggalKunci.getMonth(), this.tanggalKunci.getDate())
                    }]
                };
                
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.unit_kerja_id = this.unitkerjas[0].id;
                //this.form.penyedia_id = 1400;
            },

            loadAccModal(barang_masuk){  
                //alert(barang_masuk.status_terima)
                if(barang_masuk.status_terima == '' || barang_masuk.status_terima == '0'){
                    this.statusTerima = false;
                }else{
                    this.statusTerima = true;

                    if(barang_masuk.status_terima == '1'){
                        this.statusTerimaStr = "Ditolak/ Dikembalikan";
                    }else if(barang_masuk.status_terima == '2'){
                        this.statusTerimaStr = "Diterima";
                    }
                }

		        this.form.reset();
                $('#modalACC').modal('show');
                this.form.fill(barang_masuk);

		        if(barang_masuk.tgl_verif == '' || barang_masuk.tgl_verif == '0' || barang_masuk.tgl_verif == null){
			        this.form.tgl_verif = dtFormatter(new Date());
		        }
            },

            loadBarangMasuks(){
                /*this.$Progress.start();

                let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;

                axios.get("/api/barang_masuk?search=" + param + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.barangmasuks = data.data.barang_masuk, this.sumberdanas = data.data.sumber_dana, this.unitkerjas = data.data.unit_kerja, this.penyedias = data.data.penyedia, this.grandtotal = data.data.grand_total));

                this.$Progress.finish();*/
				
				if (!this.tahunBarangMasuk) {
					this.barangmasuks = {}
					this.grandtotal = 0
					return
				}

				this.$Progress.start()

				let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm

				axios.get("/api/barang_masuk", {
					params: {
						search: param,
						tahun: this.tahunBarangMasuk,
						status_verifikasi: this.statusVerifikasi,
						sumber_dana_id: this.filterSumberDana,
						sortIndex: this.sortIndex,
						sortDirection: this.sortDirection,
						showPage: this.perPage,
						showTable: this.showTable
					}
				}).then(({ data }) => {
					this.barangmasuks = data.data.barang_masuk
					this.sumberdanas = data.data.sumber_dana
					this.unitkerjas = data.data.unit_kerja
					this.penyedias = data.data.penyedia
					this.grandtotal = data.data.grand_total
				})

				this.$Progress.finish()
                
            },
            
            createBarangMasuk(){

                this.form.post('/api/barang_masuk')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadBarangMasuks();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            }

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            this.$Progress.start();
            //this.loadBarangMasuks();
			const now = new Date().getFullYear()
			for (let i = 0; i < 2; i++) {
				this.listTahunBarangMasuk.push(now - i)
			}
			// ⬅️ langsung load data tahun berjalan
			this.getResults(1)
  
            this.$Progress.finish();
        },
        watch: {
			//tahunBarangMasuk() {
			//	this.page = 1
			//	this.getResults(1)
			 // },
			'$route.query.tahun'(val) {
				this.tahunBarangMasuk = val
				  ? parseInt(val)
				  : new Date().getFullYear()
				
				this.page = 1
				this.getResults(1)
			  },  
            searchTerm: function() {
                this.loadBarangMasuks();
            },
			filterSumberDana() {
				this.page = 1
				this.getResults(1)
			  }
        }
    }

/*
    function returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split(','),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            }*/
    
            function dtFormatter(d) {
  const yr = d.getFullYear();
  const mnt =
    d.getMonth() + 1 < 9 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
  const day = d.getDate() < 9 ? "0" + d.getDate() : d.getDate();

  //return day + "." + mnt + "." + yr;
  return yr + "-" + mnt + "-" + day;
}        
</script>